// Tier-2 <Statistic> backed by AntD Statistic (FORT-331). A labelled metric with
// an optional prefix/suffix. The `tone` vocabulary is ours and maps the value
// colour to semantic design tokens (KPIs read consistently across screens).
import React from 'react';
import { Statistic as AntStatistic } from 'antd';
import { useTokens } from '../../core/theme/TokensProvider';
import type { CommonProps } from './types';

export type StatisticTone = 'default' | 'primary' | 'success' | 'warning' | 'danger';

export interface StatisticProps extends CommonProps {
  title?: React.ReactNode;
  value: string | number;
  precision?: number;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  tone?: StatisticTone;
}

export const Statistic: React.FC<StatisticProps> = ({
  title,
  value,
  precision,
  prefix,
  suffix,
  tone = 'default',
  className,
  style,
  'data-testid': dataTestId,
}) => {
  const tokens = useTokens();
  const valueColor =
    tone === 'default'
      ? undefined
      : tone === 'primary'
        ? tokens.color.primary
        : tokens.color[tone]; // success | warning | danger
  return (
    <AntStatistic
      title={title}
      value={value}
      precision={precision}
      prefix={prefix}
      suffix={suffix}
      valueStyle={valueColor ? { color: valueColor } : undefined}
      className={className}
      style={style}
      data-testid={dataTestId}
    />
  );
};
